<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_499_3798)">
                <mask id="mask0_499_3798" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="26"
                    height="25">
                    <path d="M25.5 0H0.5V25H25.5V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_499_3798)">
                    <mask id="mask1_499_3798" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="26" height="25">
                        <path d="M25.5 0H0.5V25H25.5V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask1_499_3798)">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M2.5 0C1.39543 0 0.5 0.89543 0.5 2V23C0.5 24.1046 1.39543 25 2.5 25H23.5C24.6046 25 25.5 24.1046 25.5 23V2C25.5 0.895431 24.6046 0 23.5 0H2.5ZM20.5607 17.7057C20.7001 17.8172 20.858 17.8637 21.016 17.8637V17.8544C21.239 17.8544 21.4527 17.7522 21.6014 17.5663C21.8523 17.2411 21.7872 16.7765 21.462 16.5256L16.3886 12.6137C16.0634 12.3628 15.5988 12.4278 15.3479 12.753C15.097 13.0783 15.162 13.5429 15.4872 13.7938L20.5607 17.7057ZM10.163 12.5302C10.005 12.5302 9.84711 12.4837 9.70768 12.3722L4.63423 8.46953C4.30901 8.21865 4.24397 7.75405 4.49485 7.42883C4.74573 7.10361 5.21034 7.03856 5.53556 7.28945L10.609 11.1921C10.9342 11.443 10.9993 11.9076 10.7484 12.2328C10.5997 12.4187 10.386 12.5209 10.163 12.5209V12.5302ZM2.79439 10.4114L9.69837 15.6707L9.70766 15.6614L16.2214 10.9782L22.3077 15.5128C22.6329 15.7636 23.1068 15.6893 23.3484 15.3641C23.5992 15.0389 23.5249 14.565 23.1997 14.3234L16.24 9.13842L9.73554 13.8216L3.69571 9.23134C3.37049 8.98046 2.90589 9.0455 2.65501 9.37072C2.40412 9.69594 2.46917 10.1605 2.79439 10.4114Z"
                            :fill="color" 
                        />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_499_3798">
                    <rect width="25" height="25" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAFPM2',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>